module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.11@core-js/library/modules/_library.js
// module id = 34
// module chunks = 69